import { ConnectionChart } from "fleet/view/device/connection-chart";
import PropTypes from "prop-types";
import React from "react";

function ConnectionChartWrapper(props) {
  const { connectionData, isShell, lastOnline } = props;

  if (isShell) {
    return (
      <div className="last-online">
        <span className="text-muted">Never connected</span>
      </div>
    );
  }

  return (
    <div>
      <ConnectionChart data={connectionData} small />
      <div className="last-online">
        <span className="text-muted">{`Last online ${lastOnline}`}</span>
      </div>
    </div>
  );
}

ConnectionChartWrapper.propTypes = {
  connectionData: PropTypes.array.isRequired,
  isShell: PropTypes.bool.isRequired,
  lastOnline: PropTypes.string.isRequired,
};

export { ConnectionChartWrapper };
